import { Navbar } from "../components/Navbar";

export function SideQuestPage() {
    return(
        <div class="catpage-sidequest">
            <Navbar />
            <h1>Coming soon!</h1>
        </div>
    );
};
